<template>
  <div class="interval-selector">
    <button
      v-for="opt in options"
      :key="opt.value"
      :class="['interval-btn', { active: opt.value === value }]"
      @click="$emit('input', opt.value)"
      type="button"
    >
      {{ opt.label }}
    </button>
  </div>
</template>

<script>
import { allowedIntervals, FALLBACK_INTERVAL } from '@/components/graph/chartTimes.js'

export default {
  name: 'IntervalSelector',
  props: {
    value: { type: String, default: FALLBACK_INTERVAL },
    /**
     * Symbol.allowedChartTimes (ChartTime enum names, e.g. ['M5', 'H1', 'D1']).
     * Null/empty on symbols that were never configured — the shared helper then
     * falls back to the default interval list.
     */
    allowedChartTimes: { type: Array, default: null },
  },
  computed: {
    options() {
      return allowedIntervals({ allowedChartTimes: this.allowedChartTimes })
        .map(value => ({ value, label: value }))
    },
  },
}
</script>

<style scoped lang="scss">
.interval-selector {
  display: flex;
  gap: 4px;
  padding: 6px 8px;
  flex-wrap: wrap;
}

.interval-btn {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: inherit;
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.4;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
  }

  &.active {
    background: rgba(0, 207, 232, 0.18);
    border-color: rgba(0, 207, 232, 0.6);
    color: #00cfe8;
  }
}
</style>
